import {initAuth} from './auth'
import {loadRoutes} from './routes'
import {loadComments} from './comments'
import {loadTags} from './tags'
import {loadTopos} from './topos'

import {loadTasks} from './tasks'
import {loadTests} from './tests'


let _dispatch

export function init() {
  return (dispatch,getState) => {
    _dispatch = dispatch
    dispatch(initAuth())
    dispatch(loadRoutes())
    dispatch(loadComments())
    dispatch(loadTags())
    dispatch(loadTopos())
  }
}


export function initLogbook() {
  return (dispatch,getState) => {
    _dispatch = dispatch
    dispatch(initAuth())
    dispatch(loadRoutes())
    dispatch(loadTasks())
    dispatch(loadTests())
    dispatch(loadComments())
  }
}


export  function notify({event,message}) {
  console.log('notify _dispatch')
  _dispatch({
    type: 'notify',
    data: {event,message},
  })
}



/** WEBPACK FOOTER **
 ** ./src/app/actions/init.js
 **/